
import { Component, Vue } from 'vue-property-decorator';
import { chartData } from '@/assets/data/dataCharts';
import { AreaType, ScenarioType, SectorType } from '@/types';
import { DataFilterMutations } from '@/store/mutations/dataFilterMutations';

@Component
export default class DataTableOfContents extends Vue {
  chartData = chartData;

  get selectedArea(): AreaType {
    return this.$store.getters.selectedArea;
  }

  get selectedScenarios(): ScenarioType[] {
    return this.$store.getters.selectedScenarios;
  }

  get selectedSector(): SectorType {
    return this.$store.getters.selectedSector;
  }

  get selectedChart(): number | null {
    return this.$store.getters.selectedChart;
  }

  set selectedChart(newVal: number | null) {
    this.$store.commit(DataFilterMutations.SET_SELECTED_CHART, newVal);
  }

  get sidebarData() {
    return this.$store.getters.availableCharts;
  }
}
